'use client';

import { KeyTextField, LinkField, RichTextField } from '@prismicio/client';
import styles from './TextBlock.module.scss';
import { Button } from '@/components';
import { BulletIcons } from '@/assets';
import { HelocSubtitle } from './HelocSubtitle/HelocSubtitle';
import { useVisible } from '@/hooks';
import { HelocTitle } from './HelocTitle/HelocTitle';

interface Props {
  subtitle: RichTextField;
  button_link: LinkField;
  button_text: KeyTextField;
  titles: KeyTextField[];
  activeItem: number;
  onClick: (_index: number) => void;
}

const TextBlock = ({
  subtitle,
  button_link,
  button_text,
  titles,
  activeItem,
  onClick,
}: Props) => {
  const [isVisible, id] = useVisible();

  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <article className={styles.wrapper} id={id}>
      <HelocSubtitle subtitle={subtitle} isVisible={isVisible} />
      <ul className={`${styles.titlesList} ${isVisibleStyles}`}>
        {titles.map((title, index) => (
          <HelocTitle
            key={index}
            isActive={activeItem === index}
            title={title}
          />
        ))}
      </ul>
      <div className={`${styles.button_wrapper} ${isVisibleStyles}`}>
        <Button text={button_text} link={button_link} styles={styles.button} />
      </div>
      <div className={`${styles.numbers} ${isVisibleStyles}`}>
        {titles.map((_title, index) => (
          <div key={_title as string} className={styles.number_item}>
            <button
              type="button"
              className={`${styles.number_button} ${activeItem >= index ? styles.isActive : styles.isHidden}`}
              onClick={() => onClick(index)}
            >
              <span>0{index + 1}</span>
              <div className={styles.icons_wrapper}>
                <BulletIcons icon="circle transparent" />
                <BulletIcons icon="circle dark" />
              </div>
            </button>
          </div>
        ))}
        <div className={styles.line_wrapper}>
          <span className={styles.line} />
          <span
            className={styles.progress}
            style={{ width: `${(100 / (titles.length - 1)) * activeItem}%` }}
          />
        </div>
      </div>
    </article>
  );
};

export default TextBlock;
